import { authService } from '@/core/auth/export';
import notificationApi from '@/core/notifications/api/notification-api';

// The notification service owns the in-app topic (GET /me/profile → inAppTopic); the UI must not
// build it. Fetched once and shared by every subscriber; cleared on logout and after a failure.
let inAppTopicPromise: Promise<string | undefined> | null = null;

export function getInAppTopic(): Promise<string | undefined> {
  if (!inAppTopicPromise) {
    inAppTopicPromise = notificationApi
      .getProfile()
      .then(profile => profile.inAppTopic || undefined)
      .catch(err => {
        inAppTopicPromise = null;
        console.warn('Could not load the in-app notifications topic', err);
        return undefined;
      });
  }
  return inAppTopicPromise;
}

export function clearInAppTopic(): void {
  inAppTopicPromise = null;
}

authService.onLogout(clearInAppTopic);
